/**
 * 马来西亚 Xiaomi Care 使用条款链接。
 * 自马来当地时间 2026-10-01 00:00:00 起由旧地址切换到新版地址。
 */

// 马来（Asia/Kuala_Lumpur）恒为 UTC+8 且无夏令时，故偏移量可固定。
// 注意不要用设备本地时区判断（getFullYear/getMonth/getDate 取的是设备时区），
// 否则设备时区非东八区时切换时刻会偏移。
const MY_OFFSET_MS = 8 * 60 * 60 * 1000;

// 马来本地 2026-10-01 00:00:00 对应的绝对时刻
const SWITCH_AT_MS = Date.UTC(2026, 9, 1) - MY_OFFSET_MS;

export const CARE_URL_OLD = 'https://www.mi.com/my/support/terms/xiaomi-care/';
export const CARE_URL_NEW = 'https://www.mi.com/my/support/terms/xiaomi-care-2026-10/';

export function getXiaomiCareUrl(nowMs: number = Date.now()): string {
  return nowMs >= SWITCH_AT_MS ? CARE_URL_NEW : CARE_URL_OLD;
}
